export default __webpack_public_path__ + "static/iam_role_09-f6e11841d45b22dc520deec98d211ff4.png";